// extracted by mini-css-extract-plugin
module.exports = {"link":"Search_link__2uwRj","searchBox":"Search_searchBox__2157V","searchResults":"Search_searchResults__1Xsvy"};